<template>
  <div class="container">
    <div class="row">
      <div class="text--base chart__white">
        <PyramidPayments v-if="pyramidTitle" :content="pyramidTitle" />
      </div>
    </div>
  </div>
</template>

<script>
import { json as fetchJson } from 'd3';
import PyramidPayments from '@/components/content/chapter2/PyramidPayments.vue';

export default {
  name: 'App3Pyramid',
  components: {
    PyramidPayments,
  },
  data() {
    return {
      content: {},
    };
  },
  computed: {
    pyramidTitle() {
      return this.content.sections ? this.content.sections.find((d) => d.id === 'pyramid-payments') : {};
    },
  },
  async created() {
    this.content = await fetchJson(`${process.env.BASE_URL}data/content/chapter-02.json`);
  },
};
</script>

<style scoped lang="scss">
  .chart__white {
    background-color: #ffffff;
    padding: 60px 0;

    @media #{map-get($media-breakpoints, 'mobile')} {
      padding: 30px 0px;
    }
  }
</style>